import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, of, tap } from 'rxjs';

import * as fromReptActions from './rept.actions';
import { ReportsMiscDomainService } from '@apps/rept/domain';
import { Report } from '@apps/rept/domain/models/report';
import { NotfGravity, NotifType, NotificationService } from '@common/services';
import { ShortRecipient } from '@apps/rept/domain/models';

@Injectable()
export class BackReptEffects {
    constructor(
        private actions: Actions,
        private reportsMiscDomainService: ReportsMiscDomainService,
        private notificationService: NotificationService
    ) { }

    backReptAddDefaultContractualReportsRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromReptActions.BackReptAddDefaultContractualReportsRequested),
                    switchMap(({ entityId }: { entityId: string, internalRecipients: string[], externalRecipients: ShortRecipient[] }) =>
                        this.reportsMiscDomainService.addDefaultContractualReports(entityId)
                            .pipe(
                                map((reports: Report[]) =>
                                    fromReptActions.BackReptAddDefaultContractualReportsSucceeded({ reports })
                                ),
                                catchError(() =>
                                    of(fromReptActions.BackReptAddDefaultContractualReportsFailed())
                                )
                            )
                    )
                )
    );

    backReptAddDefaultContractualReportsSucceeded = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromReptActions.BackReptAddDefaultContractualReportsSucceeded),
                    tap(({ reports }: { reports: Report[] }) => {
                        if (!reports || reports.length === 0) {
                            this.notificationService.notify(
                                ['', 'Aucun rapport créé. Les rapports contractuels existent déjà. '],
                                NotfGravity.warning2,
                                NotifType.SNACKBAR
                            );
                            return;
                        }
                        this.notificationService.notify(
                            ['', `Rapport(s) ${reports.map(r => `'${r.name}'`).join()} créé(s)`],
                            NotfGravity.success,
                            NotifType.SNACKBAR
                        );
                    })
                ),
        { dispatch: false }
    );
}
